import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { MatTabHeader } from '@angular/material';

@Component({
	selector: 'app-dpp-override',
	templateUrl: './dpp-override.component.html',
	styleUrls: ['./dpp-override.component.css']
})
export class DppOverrideComponent implements OnInit {

	public BAN_REGEX = /^[0-9]+$/;
	public NUMBER_REGEX = /^[0-9]+(.[0-9]+)?$/;
	public billingAccountNumber : string = '';
	public banLookupErrorMessage : string = '';
	public hasBanLookupError : boolean = false;
	public hasResultData : boolean = false;
	public hasNumericalNewFinalBalance : boolean = false;
	public hasNumericalPayoffPercentage : boolean = false;
	public hasSuccessfulOverride : boolean = false;
	public hasFailedOverride : boolean = false;
	private screen: string = 'dpp_override';
	public data : Object = {
		"fullName" : '',
		"billingAccountBalance" : 0,
		"dppBalance" : 0,
		"payoffPercentage" : 0,
		"newDppFinalBalance" : 0,
		"dppBalanceIncrease" : 0
	};



	constructor(private sharedService: SharedService, private localStorageService: LocalStorageService)
	{
		this.sharedService.setHeaderTitle(this.screen);
		this.sharedService.IsTheSessionValid(this.screen, true);
	}

	public is_super_admin: boolean;

	ngOnInit() {
		this.is_super_admin = this.localStorageService.get('isSuperAdmin');
	}

	resetBanLookup(){
		this.hasResultData = false;
		this.hasSuccessfulOverride = false;
		this.hasFailedOverride = false;
		this.hasBanLookupError = false;
		this.banLookupErrorMessage = "";
	}

	validatePayoffPercentageInput(){
		if(this.data["payoffPercentage"].toString().match(this.NUMBER_REGEX)){
			this.hasNumericalPayoffPercentage = true;
		}
		else{
			this.hasNumericalPayoffPercentage = false;
		}
	}

	validateFinalBalanceInput(event : Event){
		if(this.data["newDppFinalBalance"].toString().match(this.NUMBER_REGEX)){
			const replaceText = this.data["newDppFinalBalance"].replace(',', '.');
			this.data["newDppFinalBalance"] = replaceText
			this.hasNumericalNewFinalBalance = true;
			this.calculateBalanceIncrease();
		}
		else{
			this.hasNumericalNewFinalBalance = false;
		}
	}

	submitBan(){
		this.resetBanLookup();
		this.sharedService.setLoader(this.screen, true);
		var request = {
			"BillingAccountNumber": this.billingAccountNumber,
			"Token": this.localStorageService.get("agentToken")
		};
		this.sharedService.requestDppOverrideData(request)
			.then(res => {
				this.hasBanLookupError = false;
				this.data = res;
				this.calculateBalanceIncrease();
				this.hasNumericalNewFinalBalance = true;
				this.hasNumericalPayoffPercentage = true;
				this.hasResultData = true;
				this.sharedService.setLoader(this.screen, false);
			})
			.catch(err => {
				this.hasBanLookupError = true;
				this.hasResultData = false;
				this.data = {
					"fullName" : '',
					"billingAccountBalance" : 0,
					"dppBalance" : 0,
					"payoffPercentage" : 0,
					"newDppFinalBalance" : 0,
					"dppBalanceIncrease" : 0
				};
				this.banLookupErrorMessage = JSON.parse(err["_body"])["message"];
				this.sharedService.setLoader(this.screen, false);
			})
	}

	submitOverride(){
		this.sharedService.setLoader(this.screen, true);
		var request = {
			"BillingAccountNumber": this.billingAccountNumber,
			"Token": this.localStorageService.get("agentToken"),
			"PayoffPercentage": this.data["payoffPercentage"],
			"NewDppFinalBalance": this.data["newDppFinalBalance"]
		};
		this.sharedService.submitDppOverride(request)
			.then(res =>{
				this.hasSuccessfulOverride = true;
				this.hasFailedOverride = false;
				this.sharedService.setLoader(this.screen, false);
				console.log(res);
			})
			.catch(err =>{
				this.hasSuccessfulOverride = false;
				this.hasFailedOverride = true;
				this.sharedService.setLoader(this.screen, false);
				console.log(err);
			})
	}

	calculateBalanceIncrease(){
		this.data["dppBalanceIncrease"] = (this.data["newDppFinalBalance"] - this.data["dppBalance"]).toFixed(2);
	}

}



// WEBPACK FOOTER //
// ./src/app/agent/agent-dashboard/dpp-override/dpp-override.component.ts